import { render, staticRenderFns } from "./doodle.vue?vue&type=template&id=3a5895a6&scoped=true&"
var script = {}
import style0 from "./doodle.vue?vue&type=style&index=0&id=3a5895a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5895a6",
  null
  
)

export default component.exports